import type BackOfficeConnector from "../data/backOfficeConnector";
import DistributorRefundCandidateSummaryResponse from "../entities/distributorRefundCandidateSummaryResponse";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";
import DistributorRefundCandidatesResponse from "../entities/distributorRefundCandidatesResponse";
import type ApproveDistributorRefundCandidatesRequest from "../entities/approveDistributorRefundCandidatesRequest";

export default class DistributorRefundsRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getApiV1CallCenterDistributorsDistributorIdPaymentRequestsPaymentRequestIdRefundCandidates(
    distributorId: string,
    paymentRequestId: string
  ) {
    return this.callApi(
      api =>
        api
          .path(`call_center/distributors/${distributorId}/payment_requests/${paymentRequestId}/refund_candidates`)
          .getEntity(DistributorRefundCandidatesResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
    // HTTP 200: DistributorRefundCandidatesResponse
    // HTTP 400: ValidationErrorResponse
    // HTTP 401: ErrorResponse
    // HTTP 403: ErrorResponse
  }

  getApiV1CallCenterDistributorsRefundCandidates() {
    return this.callApi(api =>
      api.all("call_center").all("distributors").all("refund_candidates").getEntities(DistributorRefundCandidateSummaryResponse)
    );
  }

  deleteApiV1CallCenterDistributorsDistributorIdPaymentRequestsPaymentRequestIdRefundCandidates(
    distributorId: string,
    paymentRequestId: string
  ) {
    return this.callApi(api =>
      api.path(`call_center/distributors/${distributorId}/payment_requests/${paymentRequestId}/refund_candidates`).delete({})
    );
    // HTTP 204: DistributorRefundCandidatesResponse
    // HTTP 400: ValidationErrorResponse
    // HTTP 401: ErrorResponse
    // HTTP 403: ErrorResponse
  }

  postApiV1CallCenterDistributorsDistributorIdPaymentRequestsPaymentRequestIdRefundCandidatesApprovals(
    distributorId: string,
    paymentRequestId: string,
    payload: ApproveDistributorRefundCandidatesRequest
  ) {
    return this.callApi(
      api =>
        api
          .path(`call_center/distributors/${distributorId}/payment_requests/${paymentRequestId}/refund_candidates/approvals`)
          .postOnly(payload),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
    // HTTP 204: DistributorRefundCandidatesResponse
    // HTTP 400: ValidationErrorResponse
    // HTTP 401: ErrorResponse
    // HTTP 403: ErrorResponse
  }

  postApiV1CallCenterDistributorsDistributorIdPaymentRequestsPaymentRequestIdRefundCandidatesRefunds(
    distributorId: string,
    paymentRequestId: string
  ) {
    return this.callApi(api =>
      api
        .path(`call_center/distributors/${distributorId}/payment_requests/${paymentRequestId}/refund_candidates/refunds`)
        .postOnly({})
    );
    // HTTP 204: DistributorRefundCandidatesResponse
    // HTTP 400: ValidationErrorResponse
    // HTTP 401: ErrorResponse
    // HTTP 403: ErrorResponse
  }
}
